import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("qissa_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // bust browser cache on GETs so admin edits always show immediately
  if ((config.method || "get").toLowerCase() === "get") {
    config.params = { ...(config.params || {}), _t: Date.now() };
  }
  return config;
});

// resolve media urls that come back as /api/files/... to absolute
export const mediaUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
};

// like mediaUrl but asks the backend for a resized + webp-compressed copy.
// use for covers / thumbnails so huge source images load fast. Full-res
// viewers (lightbox, magazine deck, flipbook) should keep using mediaUrl.
export const imgUrl = (url, width = 1200) => {
  const base = mediaUrl(url);
  if (!base) return "";
  if (base.includes("/api/files/")) {
    return `${base}${base.includes("?") ? "&" : "?"}w=${width}`;
  }
  return base;
};

export const CATEGORIES = [
  "Branding",
  "Social Media",
  "Packaging",
  "AI Visuals",
  "Catalog & Publication",
  "UI UX",
];

// a project may have multiple categories; fall back to legacy single `category`
export const projectCategories = (p) =>
  p && p.categories && p.categories.length ? p.categories : p && p.category ? [p.category] : [];
